import styled, { css } from 'styled-components'
import React from 'react'
import { CouponMapProps } from 'src/pages/CouponMapPage'
import RenderIf from 'src/components/common/RenderIf'
import {
  ChipsDefaultStyle,
  ChipsItemsMiddleStyle,
  ChipsItemStyle,
  ChipsListStyle,
} from 'src/components/common/Chips'
import { Container } from 'src/components/common/Container'
import usePageNav from 'src/hooks/usePageNav.hook'
import { Icon } from 'src/assets/svg/Icon'
import { CustomSwiper } from 'src/components/common/CustomSwiper'
import { layoutMaxSize } from 'src/styles/mixin'
import { Noto_body2_b14, Noto_body2_m14 } from 'src/styles/fonts/NotoSansKrFonts'

const CouponMapHeader = ({
  searchBrandList,
  bottomSheetToggle,
  filterBrand,
  handleSearchBrandListFilter,
}: Pick<
  CouponMapProps,
  'searchBrandList' | 'bottomSheetToggle' | 'filterBrand' | 'handleSearchBrandListFilter'
>) => {
  const { navigatePrev } = usePageNav()
  return (
    <S.CouponMapHeader>
      <RenderIf when={!bottomSheetToggle}>
        <S.IconContainer>
          <Icon.ArrowBack onClickFn={navigatePrev} />
        </S.IconContainer>
      </RenderIf>
      <RenderIf when={!!searchBrandList}>
        <CustomSwiper.Wrap type="default" gap={6} $wrapstyle={S.SelectedBrandChipsListStyle}>
          {searchBrandList?.map((brand, i: number) => (
            <CustomSwiper.Item
              key={i}
              onClick={() => handleSearchBrandListFilter(brand)}
              $itemstyle={S.BrandChipsItemsStyle(brand.brandNumber === filterBrand?.brandNumber)}
            >
              {brand?.brandName}
            </CustomSwiper.Item>
          ))}
        </CustomSwiper.Wrap>
      </RenderIf>
    </S.CouponMapHeader>
  )
}
export default CouponMapHeader

const S = {
  CouponMapHeader: styled.header`
    height: 50px;
    gap: 4px;
    display: flex;
    align-items: center;
    position: absolute;
    padding-left: 10px;
    background: transparent;
    z-index: 100;
    width: 100%;
    ${layoutMaxSize};
  `,
  IconContainer: styled(Container)`
    width: fit-content;
    border-radius: 10px;
    box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.1);
    cursor: pointer;
  `,
  SelectedBrandListContainer: styled(Container)`
    position: relative;
  `,
  SelectedBrandChipsListStyle: css`
    ${ChipsListStyle()};
    gap: 4px;
    padding: 6px 6px 6px 6px;
  `,
  BrandChipsItemsStyle: (active: boolean) => css`
    ${ChipsItemStyle};
    ${ChipsItemsMiddleStyle};
    gap: 4px;

    ${!active &&
    css`
      ${ChipsDefaultStyle()};
      ${Noto_body2_m14};
    `}

    ${active &&
    css`
      ${Noto_body2_b14};
      border: 1px solid var(--brand-40);
      color: var(--brand-50);
      background: var(--brand-5);
      box-shadow: 0 2px 6px 0 rgba(0, 131, 252, 0.4);
    `}
  `,
}
